/** PHP DateTime::modify day offsets preserve local wall time, including DST gaps and folds. */
export function localDayOffset(start: Date, days: number, timezone: string): number {
    const format = new Intl.DateTimeFormat('en-US', { timeZone: timezone, year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' });
    const wall = (date: Date): number => {
        const p = Object.fromEntries(format.formatToParts(date).map(part => [part.type, Number(part.value)]));
        return Date.UTC(p.year!, p.month! - 1, p.day!, p.hour!, p.minute!, p.second!);
    };
    const wanted = wall(start) + days * 86400000;
    const near = start.getTime() + days * 86400000;
    // Include both offsets around the destination. A gap has no exact candidate: PHP advances it by the gap.
    const offsets = new Set([-2, -1, 0, 1, 2].map(day => {
        const instant = near + day * 86400000;
        return wall(new Date(instant)) - instant;
    }));
    const candidates = [...offsets].map(offset => wanted - offset).sort((a, b) => a - b);
    const exact = candidates.filter(instant => wall(new Date(instant)) === wanted);
    if (exact.length) {
        // PHP preserves the source offset in a repeated hour when that offset is still valid.
        const sourceOffset = wall(start) - start.getTime();
        return exact.find(instant => wanted - instant === sourceOffset) ?? exact[0]!;
    }
    return candidates.filter(instant => wall(new Date(instant)) > wanted)
        .sort((a, b) => wall(new Date(a)) - wall(new Date(b)))[0] ?? near;
}
